<template>
  <footer class="bd-footer">
    <b-container>
      <b-row class="justify-content-md-end">
        <div class="bd-footer-copyright">Website design © 2018 4C Electronics Ltd.</div>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
export default {
    
}
</script>

<style>
.bd-footer {
  margin-top: 2em;
  border-top: .2rem #f7f7f7 solid !important;
}

.bd-footer-copyright {
  font-size: 0.65em;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
</style>
